<template>
  <div id="Wix" style="margin-left:10%;padding-top:5rem">
    <img
    src="@/assets/img/integration/Wix-logo.png"
    style="max-width: 25%; margin:auto; display:block"
    />
    <h2 class="mt-5 documentation-header">How to Setup a Cense AI Chatbot for Wix</h2>

    <div style="margin-top: 5%">
      <h6>1. Login to your Wix.com account</h6>
      <br />
      <h6>
        2. In Wix Dashboard, select the website to be edited. Go to "Edit Site".
        Clicking on "Edit Site" will open up Website Editor.
      </h6>
      <br />
      <h6>
        3. Click Add (it's the plus sign on the menu to the left in WIX editor)
      </h6>
      <img src="@/assets/img/integration/wix2.png" />
      <br />
      <br />
      <h6>
        4. Then click More at the bottom of the list and choose HTML Code.
      </h6>
      <br />
      <img src="@/assets/img/integration/wix21.png" />
      <br />
      <br />
      <h6>
        5. On the HTML settings screen click the ENTER CODE button. A small
        window will open up, copy the Widget Code from Wix Settings (in
        Miscellaneous Menu of Cense Portal) and paste it in this box. Then click UPDATE. Close the HTML settings box.
      </h6>
      <br />
      <img src="@/assets/img/integration/Wix_Add_Code.jpg" style="width: 100vh" />
      <br />
      <br />
      <h6>
        6. Now right-click on the HTML Box and select Arrange => Move Backward;
        as shown below
      </h6>
      <br />
      <img src="@/assets/img/integration/Wix_menu_drop.jpg" style="width: 150vh" />
      <br />
      <br />
      <h6>7. Click on the Pin Settings (circled below).</h6>
      <br />
      <img src="@/assets/img/integration/Wix_Pin_Settings.jpg" style="width: 150vh" />
      <br />
      <br />
      <h6>8. Set the bottom-right position for the chatbot as shown</h6>
      <br />
      <img src="@/assets/img/integration/Wix_Pin_Screen.png" style="width: 100vh" />
      <br />
      <br />
      <h6>
        9. Select the Toolbar from the Tools menu and adjust the Height and
        Width as shown below
      </h6>
      <br />
      <h6>Height: 500px and Width: 345px</h6>
      <br />
      <img src="@/assets/img/integration/Wix_HW.jpg" style="width: 100vh" />
      <br />
      <br />
      <h6>
        10. Once the above steps are successfully completed, the chatbot widget
        should appear at the bottom-right corner of your website.
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: "wix",
};
</script>

<style scoped>
h6 {
  font: normal normal normal 1rem/2.5rem Poppins;
}
</style>